import React from 'react';
import HeadingBlock from '$/components/global/heading';
import './index.scss';

const Disclosures: React.FC = () => {
  return (
    <React.Fragment>
      <section>
        <HeadingBlock title="Disclosures" />
        <div className="terms_privacy">
          <p>
            CreditSights, Inc. ("CreditSights") does not provide any investment advice. Under no circumstances will
            CreditSights provide any services to third parties that include investment advice, opinions or otherwise
            related to any third party’s investments or management thereof, nor shall any of the services described
            herein be construed as such.
          </p>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Disclosures;
